import { render } from "./NumericGridEditor.vue?vue&type=template&id=154d243f&scoped=true"
import script from "./NumericGridEditor.vue?vue&type=script&lang=js"
export * from "./NumericGridEditor.vue?vue&type=script&lang=js"

import "./NumericGridEditor.vue?vue&type=style&index=0&id=154d243f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154d243f"]])

export default __exports__